export default {
  page: 'Strona',
  layoutSubtitle: 'Puste ustawienia są przejmowane z układu bazowego.',
  blocksSubtitle: 'Bloki pojawiają się w raporcie w tej kolejności. Przeciągnij blok za uchwyt, aby go przesunąć.',
  resetBlocks: 'Użyj domyślnych bloków raportu',
};
